import PropTypes from "prop-types";
// form
import { useFormContext, Controller } from "react-hook-form";
// @polaris
import { Text } from "@shopify/polaris";

RHFTextMultilineField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  helpText: PropTypes.string,
  rows: PropTypes.number,
  style: PropTypes.object,
};

export default function RHFTextMultilineField({
  name,
  rules,
  label,
  placeholder,
  helpText,
  rows = 15,
  style = {},
  ...other
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <div>
          {label && (
            <Text variant="bodyMd" as="p" fontWeight="semibold" style={{ marginBottom: "8px" }}>
              {label}
            </Text>
          )}
          {helpText && (
            <Text variant="bodySm" as="p" tone="subdued" style={{ marginBottom: "16px" }}>
              {helpText}
            </Text>
          )}
          <textarea
            {...field}
            placeholder={placeholder}
            style={{
              width: "100%",
              height: `${rows * 20}px`, // Convert rows to pixels
              padding: "12px",
              border: error ? "1px solid #d72c0d" : "1px solid #d1d5db",
              borderRadius: "6px",
              fontFamily: "monospace",
              fontSize: "14px",
              lineHeight: "1.5",
              resize: "vertical",
              outline: "none",
              whiteSpace: "pre-wrap",
              backgroundColor: "#ffffff",
              ...style,
            }}
            {...other}
          />
          {error && (
            <Text variant="bodySm" tone="critical" style={{ marginTop: "4px" }}>
              {error.message}
            </Text>
          )}
        </div>
      )}
    />
  );
}
